import { Theme } from '@mui/material/styles'
export const getStyles = (theme: Theme) => ({
  billToCard: {
    margin: `${theme.spacing(2.4)} 0`,
  },

  label: {
    color: theme.palette.text.primary,
    fontFamily: 'Source Sans Pro',
    fontSize: '16px',
  },

  searchBox: {
    margin: `${theme.spacing(1.2)} 0`,
  },

  serviceLocationCard: {
    '&:not(:last-child)': {
      margin: `${theme.spacing(1.2)} 0`,
    },
    width: 'auto',
  },
})
